/* eslint-disable @typescript-eslint/no-var-requires */
import { type PropsWithChildren } from 'react';
import React from 'react';

import { isMobile } from '@south-street-app/utils';

const LaunchDarklyProvider = ({ children }: PropsWithChildren) => {
  if (isMobile) {
    const {
      LaunchDarklyMobileProvider,
    } = require('./LaunchDarklyMobileProvider');

    return <LaunchDarklyMobileProvider>{children}</LaunchDarklyMobileProvider>;
  }

  const { LaunchDarklyWebProvider } = require('@shared/providers');

  return <LaunchDarklyWebProvider>{children}</LaunchDarklyWebProvider>;
};

export { LaunchDarklyProvider };
